import { useStoreContext } from './useStoreContext'

const useShowPrice = (): boolean => {
  const store = useStoreContext()
  return !store.digitalCatalog
}

export default useShowPrice
